import React from 'react';
import Icon from '../Icon/Icon';
import { string, node } from 'prop-types';

const propTypes = {
  icon: string.isRequired,
  title: node.isRequired,
  name: string.isRequired,
  link: string,
};

const OfferTopLinkItem = ({ icon, title, name, link }) => {
  return (
    <li className="elem">
      <Icon type={icon} />
      <span className="elem-content">
        {title}:
        {link ? (
          <a target="_blank" href={link}>
            {name}
          </a>
        ) : (
          <span className="source">{name}</span>
        )}
      </span>
    </li>
  );
};

OfferTopLinkItem.propTypes = propTypes;

export default OfferTopLinkItem;
